import { MonsterConfig } from "../Monster";
import IMobGenerate from "./IMobGenerate";
import IntervalMobGenerator from "./IntervalMobGenerator";
import { DefaultPositioner } from "./MobGenerators/DefaultPositioner";
import IPositioner from "./MobGenerators/IPositioner";
import { YAxisPositioner } from "./MobGenerators/YAxisPositioner";
import { Monsters } from "./Monsters";
import OneTimeMobGenerator from "./OneTimeMobGenerator";

/**
 *          "Generators": [{
                        "Type": "Interval",
                        "DurationActiveMinutes": 1,
                        "IntervalSpawnSeconds": 5,
                        "DelaySecondUntilBegin": 0,
                        "IsActive": true,
                        "Mobs": ["PracticeHayTarget"]
                    },
                    {
                        "Type": "OneTime",
                        "DelaySecondUntilBegin": 50,
                        "IsActive": true,
                        "Mobs": ["PracticeHayBlock"]
            
                    }
                ]
 */
export default class MobGeneratorFactory {
    static Create(type: string, monsters: string[], jsonConfig): IMobGenerate {
        let monsterConfigsToInitialtie: MonsterConfig[] = [];

        monsters.forEach(monsterName => {

            Monsters.AllMobs.forEach(monsterConfig => {

                if (monsterConfig.Name == monsterName) {
                    monsterConfigsToInitialtie.push(monsterConfig);
                }
            });
        });

        let positioner: IPositioner = new DefaultPositioner();

        if (jsonConfig.Positioner !== undefined
            && jsonConfig.Positioner.Type !== undefined
            && jsonConfig.Positioner.Type === "YAxis") {
            positioner = new YAxisPositioner(jsonConfig.Positioner.MinY, jsonConfig.Positioner.MaxY)
        }

        if (type == "Interval") {
            let intervalG = new IntervalMobGenerator(monsterConfigsToInitialtie);
            intervalG.DelaySecondUntilBegin = jsonConfig.DelaySecondUntilBegin;
            intervalG.DurationActiveMinutes = jsonConfig.DurationActiveMinutes;
            intervalG.IntervalSpawnSeconds = jsonConfig.IntervalSpawnSeconds;
            intervalG.TimesLimit = jsonConfig.TimesLimit;
            intervalG.Positioner = positioner;
            return intervalG;
        }
        else if (type == "OneTime") {
            let oneTimeG = new OneTimeMobGenerator(monsterConfigsToInitialtie);
            oneTimeG.DelaySecondUntilBegin = jsonConfig.DelaySecondUntilBegin;
            oneTimeG.DurationActiveMinutes = jsonConfig.DurationActiveMinutes;
            oneTimeG.Positioner = positioner;

            return oneTimeG;
        }
        else {
            let intervalG = new IntervalMobGenerator(monsterConfigsToInitialtie);
            intervalG.DelaySecondUntilBegin = jsonConfig.DelaySecondUntilBegin;
            intervalG.DurationActiveMinutes = jsonConfig.DurationActiveMinutes;
            intervalG.IntervalSpawnSeconds = jsonConfig.IntervalSpawnSeconds;
            intervalG.TimesLimit = jsonConfig.TimesLimit;
            intervalG.Positioner = positioner;
            return intervalG;
        }
    }
}